import { GET_NOTIFICATION_FAIL, GET_NOTIFICATION_LOADING, GET_NOTIFICATION_SUCCESS, GET_SETTINGS_FAIL, GET_SETTINGS_LOADING, GET_SETTINGS_SUCCESS, SETTINGS_UPDATE, SETTINGS_UPDATE_FAIL, SETTINGS_UPDATE_LOADING, SETTINGS_UPDATE_SUCCESS } from "./actionType"

//update settings
const initialState = {
  error: "",
  success: "",
  loading: false
}

const SettingsUpdate = (state = initialState, action) => {
  switch (action.type) {
    case SETTINGS_UPDATE:
      state = {
        ...state,
      }
      break
    case SETTINGS_UPDATE_SUCCESS:
      
      state = { ...state, success: action.payload,loading:false }
      break
    case SETTINGS_UPDATE_FAIL:
      state = { ...state, error: action.payload,loading:false }
      break
    case SETTINGS_UPDATE_LOADING:
      state = {
        loading: action.payload
      }
  }
  return state
}

export default SettingsUpdate

// get settings
const initialState_GetSettings = {
  data: [],
  error: "",
  success: "",
  loading: false
}

export const GetSettings = (state = initialState_GetSettings, action) => {
  switch (action.type) {
    case GET_SETTINGS_SUCCESS: 
      return {
        ...state,
        data: action.payload,
        loading: false
      }
    case GET_SETTINGS_FAIL:
      return {  
        ...state,
        error: action.payload,
        loading: false
      }
    case GET_SETTINGS_LOADING:
      return {
        ...state,
        loading: action.payload, 
      }
  }
  return state
}


// get Notification
const initialState_GetNotification = {
  data: [],
  error: "",
  success: "",
  loading: false
}

export const GetNotification = (state = initialState_GetNotification, action) => {
  switch (action.type) {
    case GET_NOTIFICATION_SUCCESS:  
      return {
        ...state,
        loading: false,
        data: action.payload,
      }
    case GET_NOTIFICATION_FAIL:
      return {  
        ...state,
        error: action.payload,
        loading: false
      }
    case GET_NOTIFICATION_LOADING:
      return {
        ...state,
        data: [],
        loading: action.payload, 
      }
  }
  return state
}